<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" >
        <v-card :loading="loading">
            <v-toolbar flat color="primary"></v-toolbar>
            <v-divider></v-divider>
            <v-data-table locale="pt-BR" 
                            dense fixed-header 
                            class="table-item" 
                            :items="cursos" 
                            :headers="fields" 
                            :items-per-page="15">

                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon color="primary" @click="editar(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon class="mx-1" color="primary" @click="ativar(item)">
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                        </template>
                        <span>ativar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon color="primary"  @click="excluir(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Excluir</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showSuccess, showError } from "@/config/global"

export default {
    name: 'cursosInativos',
    props:['mostrar','cursos'],
    data(){
        return{
            fields: [
					{value: 'id', text: 'Código'},
					{value: 'nome', text: 'Nome'},
					{value: 'nome_instrutor', text: 'Instrutor'},
                    {value: 'grau', text: 'Grau'},
                    {value: 'data_criacao', text: 'Data Criação'},
                    {text: 'Ações', value: 'action', align: 'center', divider: true}
                    
                ],
            loading: false,
        }
    },
    methods:{

        ativar(item){
            const url = `${baseApiUrl}/Cursos/ativar.php` 
				        
            axios.post(url, item).then(res => {
                
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)	
                    this.$emit('ativarCurso', item)
                }else{
                    showError(res.data.mensagem)
                }
                
            })
        },

        editar(item){
            this.$emit('editarCurso', item)
        },

        excluir(item){
            this.$emit('excluirCurso', item)
        },

        fechar(){
            this.$emit('fechar')
        },
    },
}
</script>